import React from "react";

const TrustedHealthcareSection = () => {
  return (
    /* Trusted Healthcare (progress bars) start */
    <section className="prt-row padding_zero-section prt-bg bg-base-dark z-index-0 clearfix">
      <div className="prt-row-wrapper-bg-layer prt-bg-layer bg-base-dark"></div>
      <div className="container-fluid">
        <div className="row">
          {/* Left Column with Progress Bars */}
          <div className="col-xl-6 col-lg-12">
            <div className="prt-bg bg-base-lightgrey spacing-1">
              <div className="prt-col-wrapper-bg-layer prt-bg-layer">
                <div className="prt-col-wrapper-bg-layer-inner"></div>
              </div>
              <div className="layer-content">
                <div className="position-relative">
                  <h3 className="fs-46 mb-30 text-base-white progressbar-title">
                    Nuestro método:
                  </h3>
                  {/* progress bar 1 */}
                  <div className="prt-progress-bar style1" data-percent="60%">
                    <div className="progress-bar-title d-flex justify-content-between">
                      <h3 className="progress-title">Eleccion saludable de alimentos</h3>
                      <h3 className="progress-percentage counter">40%</h3>
                    </div>
                    <div className="progress-bar-inner">
                      <div
                        className="progress-bar progress-bar-color-bar_skincolor"
                        style={{ width: "40%" }}
                      ></div>
                    </div>
                  </div>
                  {/* progress bar 2 */}
                  <div className="prt-progress-bar style1" data-percent="50%">
                    <div className="progress-bar-title d-flex justify-content-between">
                      <h3 className="progress-title">Cantidad correcta por ingesta</h3>
                      <h3 className="progress-percentage counter">30%</h3>
                    </div>
                    <div className="progress-bar-inner">
                      <div
                        className="progress-bar progress-bar-color-bar_skincolor"
                        style={{ width: "30%" }}
                      ></div>
                    </div>
                  </div>
                  {/* progress bar 3 */}
                  <div className="prt-progress-bar style1" data-percent="80%">
                    <div className="progress-bar-title d-flex justify-content-between">
                      <h3 className="progress-title">Actividad física</h3>
                      <h3 className="progress-percentage counter">30%</h3>
                    </div>
                    <div className="progress-bar-inner">
                      <div
                        className="progress-bar progress-bar-color-bar_skincolor"
                        style={{ width: "30%" }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Right Column with Background Image */}
          <div className="col-xl-6 col-lg-12">
            <div className="prt-bg prt-col-bgimage-yes col-bg-img-one spacing-2">
              <div className="prt-col-wrapper-bg-layer prt-bg-layer"></div>
              <div className="layer-content"></div>
            </div>
          </div>
        </div>
        <div className="row mt-20">
          <div className="col-xl-6 col-lg-12">
            <div className="prt-bg prt-col-bgimage-yes col-bg-img-two spacing-3">
              <div className="prt-col-wrapper-bg-layer prt-bg-layer"></div>
              <div className="layer-content"></div>
            </div>
            <img
              className="img-fluid prt-equal-height-image w-100 position-relative"
              src="/assets/images/bg-image/col-bgimage-2.jpg"
              alt="bg-imagen"
            />
          </div>
          <div className="col-xl-6 col-lg-12">
            <div className="prt-bg bg-base-gradient spacing-4">
              <div className="prt-col-wrapper-bg-layer prt-bg-layer">
                <div className="prt-col-wrapper-bg-layer-inner"></div>
              </div>
              <div className="layer-content">
                <div className="position-relative">
                  <h3 className="fs-46 mb-15 text-base-white fid-title">
                    En equipomag.com somos la opción más confiable
                  </h3>
                  <p>
                    Nos sentimos orgullosos de nuestro historial ofreciendo recursos basados en
                    evidencia y soluciones personalizadas. Queremos verte alcanzar tus metas de
                    salud y nutrición.
                  </p>
                  <div className="row prt-vertical_sep-fid mt-30 res-991-mt-15">
                    {/* Work Done */}
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 position-relative">
                      <div className="prt-fid inside style1">
                        <div className="prt-fid-contents">
                          <p className="prt-fid-title">Tratados</p>
                          <h4 className="prt-fid-inner">
                            <span className="numinate" data-from="0" data-to="16">
                              + 10K
                            </span>{" "}
                          </h4>
                        </div>
                      </div>
                    </div>
                    {/* Awards */}
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 position-relative">
                      <div className="prt-fid inside style1">
                        <div className="prt-fid-contents">
                          <p className="prt-fid-title">Tasa de pérdida</p>
                          <h4 className="prt-fid-inner">
                            <span className="numinate" data-from="0" data-to="30">
                              96,24%
                            </span>
                          </h4>
                        </div>
                      </div>
                    </div>
                    {/* Happy Clients */}
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 position-relative">
                      <div className="prt-fid inside style1">
                        <div className="prt-fid-contents">
                          <p className="prt-fid-title">Años de servício</p>
                          <h4 className="prt-fid-inner">
                            <span className="numinate" data-from="0" data-to="8">
                              + 8
                            </span>
                          </h4>
                        </div>
                      </div>
                    </div>
                    {/* End */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    /* Trusted Healthcare (progress bars) end */
  );
};

export default TrustedHealthcareSection;
